import { DrawerContent, DrawerDescription, DrawerRoot, DrawerTitle } from '@components/ui/drawer';
import { cn } from '@utils/cn';
import { ActionSheetProps } from './types';

export const ActionSheet = ({
  open,
  onDismiss,
  title,
  description,
  children,
  actions,
  className,
}: ActionSheetProps) => (
  <DrawerRoot
    open={open}
    direction="bottom"
    onOpenChange={(value) => {
      if (!value) onDismiss();
    }}>
    <DrawerContent
      overlayClassName="z-[70] bg-[rgba(24,28,33,.45)]"
      className={cn(
        'z-[70] max-h-[92dvh] gap-2.5 rounded-t-2xl border-0 px-4 pb-[calc(16px+env(safe-area-inset-bottom,0px))] pt-5 shadow-[0_-8px_30px_rgba(0,0,0,.18)]',
        className,
      )}>
      <DrawerTitle className="text-[19px] font-bold leading-tight text-neutral-800">
        {title}
      </DrawerTitle>
      {description && (
        <DrawerDescription className="text-sm text-neutral-600">{description}</DrawerDescription>
      )}
      {children && (
        <div className="scrollbar-thin -mr-3 min-h-0 flex-1 overflow-y-auto overscroll-contain">
          {children}
        </div>
      )}
      <div className="pt-1 [&>div]:grid [&>div]:grid-cols-[1fr_1.3fr] [&>div]:gap-2 [&>div]:space-x-0 [&_button]:h-11 [&_button]:w-full">
        {actions}
      </div>
    </DrawerContent>
  </DrawerRoot>
);
